"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SelectOption_1 = __importDefault(require("./SelectOption"));
exports.default = ({ successors, onChange, availableRules }) => (React.createElement("div", null,
    React.createElement(SelectOption_1.default, { options: ["none", "all", "specific"], names: ["None", "All", "Specific"], onChange: newValue => {
            if (newValue !== successors.kind) {
                switch (newValue) {
                    case "none":
                        onChange({ kind: "none" });
                        break;
                    case "all":
                        onChange({ kind: "all", rule: null });
                        break;
                    case "specific":
                        onChange({
                            kind: "specific",
                            rules: [null, null, null, null, null, null]
                        });
                        break;
                }
            }
        }, value: successors.kind }),
    successors.kind === "all" && (React.createElement(SelectOption_1.default, { options: availableRules, names: availableRules, onChange: r => onChange({ kind: "all", rule: r }), value: successors.rule })),
    successors.kind === "specific" && (React.createElement("div", null,
        [0, 1, 2, 3, 4, 5].map(i => (React.createElement(SelectOption_1.default, { key: i, options: ["none", ...availableRules], names: ["None", ...availableRules], onChange: newVal => {
                let val;
                if (newVal === "none") {
                    val = null;
                }
                else {
                    val = newVal;
                }
                const rules = [
                    ...successors.rules.slice(0, i),
                    val,
                    ...successors.rules.slice(i + 1)
                ];
                onChange({
                    kind: "specific",
                    rules
                });
            }, value: successors.rules[i] || "none" }))),
        React.createElement("p", null, "Rules are applied in order. If there are fewer faces than rules later rules are ignored."))),
    availableRules.length === 0 && (React.createElement("p", null, "You need to add at least one more rule in order to have any to apply to the faces of this rule."))));



// WEBPACK FOOTER //
// ./src/components/editor/SuccessorSelector.tsx